const USER_EMPTY_AVATAR = '/images/userEmptyAvatar.png';

export default USER_EMPTY_AVATAR;
